import { MimecastCgShellClient } from "./MimecastCgShellClient"
export type { Breadcrumb, MenuItem } from "./MimecastCgShellClient"

export default new MimecastCgShellClient()
